import { Box, Input, InputLabel, styled } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'

export const StyledAddressContainer = styled(Box)({
  position: 'relative',
  maxWidth: '100%',
  height: '64px',
  '& .pac-container': {
    position: 'absolute',
    zIndex: 1311,
    top: '100%!important',
    left: '0!important',
  },
  '& label + .MuiInputBase-root': {
    marginTop: 0,
  },
  '& .MuiFormHelperText-root': {
    paddingLeft: 0,
  },
})

export const StyledAddressLabel = styled(InputLabel, {
  shouldForwardProp: (prop) => prop !== 'value',
})<{ value: string }>(({ value }) => ({
  transform: value?.trim()?.length ? 'translateY(5px) scale(0.857)' : 'translateY(20px) scale(1)',
  '&.Mui-focused': {
    transform: 'translateY(5px) scale(0.857)',
  },
}))

export const StyledAddressSearchIcon = styled(SearchIcon)(({ theme }) => ({
  color: '#999',
  position: 'absolute',
  right: theme.spacing(1.5),
  bottom: '50%',
  transform: 'translateY(50%)',
  '&.MuiSvgIcon-fontSizeSmall': {
    fontSize: '1.5rem',
  },
}))

export const StyledAddressInput = styled(Input)(({ theme }) => ({
  '& .MuiInputBase-input': {
    paddingRight: theme.spacing(4.75),
  },
  '& .MuiInputBase-input:-webkit-autofill': {
    boxShadow: '0 0 0 42px white inset !important',
    webkitBoxShadow: '0 0 0 42px white inset !important',
  },
  '& .MuiInputBase-input:-webkit-autofill:hover': {
    boxShadow: '0 0 0 42px white inset !important',
    webkitBoxShadow: '0 0 0 42px white inset !important',
  },
  '& .MuiInputBase-input:-webkit-autofill:focus': {
    boxShadow: '0 0 0 42px white inset !important',
    webkitBoxShadow: '0 0 0 42px white inset !important',
  },
  '& .MuiInputBase-input:-webkit-autofill:active': {
    boxShadow: '0 0 0 42px white inset !important',
    webkitBoxShadow: '0 0 0 42px white inset !important',
  },
  '& .MuiInputBase-input:-internal-autofill-selected': {
    webkitBoxShadow: '0 0 0 42px white inset !important',
    boxShadow: '0 0 0 42px white inset !important',
  },
}))
